import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { convertDateToISO8601 } from "../../../../Utils/EsaedroHelper";

const getFirstDayOfCurrentMonth = (): Date => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();

  const firstDayOfCurrentMonth = new Date(currentYear, currentMonth, 1);
  return firstDayOfCurrentMonth;
};

const getLastDayOfCurrentMonth = (): Date => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();

  const lastDayOfCurrentMonth = new Date(currentYear, currentMonth + 1, 0);
  return lastDayOfCurrentMonth;
};

export interface ICalendar {
  [key: string]: {
    theoric: number;
    worked: number;
  };
}

interface State {
  fromDate: Date;
  toDate: Date;
  stringFromDate: string;
  stringToDate: string;

  calendar: ICalendar | null;
  // calendar: any;
}

// Define the initial state using that type
const initialState: State = {
  fromDate: getFirstDayOfCurrentMonth(),
  toDate: getLastDayOfCurrentMonth(),
  stringFromDate: convertDateToISO8601(getFirstDayOfCurrentMonth()),
  stringToDate: convertDateToISO8601(getLastDayOfCurrentMonth()),

  calendar: null,
};

export const slice = createSlice({
  name: "versamentoTempiGiornalieroSlice",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    updateDates: (
      state,
      action: PayloadAction<{
        fromDate: Date;
        toDate: Date;
      }>
    ) => {
      state.fromDate = action.payload.fromDate;
      state.toDate = action.payload.toDate;
      state.stringFromDate = convertDateToISO8601(action.payload.fromDate);
      state.stringToDate = convertDateToISO8601(action.payload.toDate);
    },

    setCalendarKey: (
      state,
      action: PayloadAction<{
        date: Date;
        theoric: number;
        worked: number;
      }>
    ) => {
      // key -> YYYY-MM-DD
      const key = convertDateToISO8601(action.payload.date);
      if (state.calendar === null) {
        state.calendar = {};
      }
      state.calendar[key] = {
        theoric: action.payload.theoric,
        worked: action.payload.worked,
      };
    },
    unsetCalendarKey: (
      state,
      action: PayloadAction<{
        date: Date;
      }>
    ) => {
      // key -> YYYY-MM-DD
      const key = convertDateToISO8601(action.payload.date);
      if (state.calendar !== null) {
        delete state.calendar[key];
      }
    },
    updateCalendarKeyTheoric: (
      state,
      action: PayloadAction<{
        date: Date;
        theoric: number;
      }>
    ) => {
      // key -> YYYY-MM-DD
      const key = convertDateToISO8601(action.payload.date);
      if (state.calendar !== null) {
        state.calendar[key].theoric = action.payload.theoric;
      }
    },
    updateCalendarKeyWorked: (
      state,
      action: PayloadAction<{
        date: Date;
        worked: number;
      }>
    ) => {
      // key -> YYYY-MM-DD
      const key = convertDateToISO8601(action.payload.date);
      if (state.calendar !== null) {
        state.calendar[key].worked = action.payload.worked;
      }
    },
    setCalendar: (state, action: PayloadAction<ICalendar>) => {
      state.calendar = action.payload;
    },

    resetVersamentoTempiGiornaliero: (state) => {
      state.fromDate = getFirstDayOfCurrentMonth();
      state.toDate = getLastDayOfCurrentMonth();
      state.stringFromDate = convertDateToISO8601(getFirstDayOfCurrentMonth());
      state.stringToDate = convertDateToISO8601(getLastDayOfCurrentMonth());

      state.calendar = null;
    },
  },
});

export const {
  updateDates,
  setCalendarKey,
  unsetCalendarKey,
  updateCalendarKeyTheoric,
  updateCalendarKeyWorked,
  setCalendar,

  resetVersamentoTempiGiornaliero,
} = slice.actions;

// Other code such as selectors can use the imported `RootState` type
// export const selectIsLoggedIn = (state: RootState) => state.user.isLoggedIn

export default slice.reducer;
